import React, { FC } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';

type DateTimeFormatOptions = {
  localeMatcher?: 'best fit' | 'lookup';
  weekday?: 'long' | 'short' | 'narrow';
  era?: 'long' | 'short' | 'narrow';
  year?: 'numeric' | '2-digit';
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  day?: 'numeric' | '2-digit';
  hour?: 'numeric' | '2-digit';
  minute?: 'numeric' | '2-digit';
  second?: 'numeric' | '2-digit';
  timeZoneName?: 'long' | 'short';
  formatMatcher?: 'best fit' | 'basic';
  hour12?: boolean;
  timeZone?: string;
};

type Props = {
  date: Date;
  options?: DateTimeFormatOptions;
};

export const DateTimeFormat: FC<Props> = ({ date, options }) => {
  const { i18n } = useTranslation();

  const formattedDate = new Intl.DateTimeFormat(i18n.language, options).format(
    date,
  );

  return <>{formattedDate}</>;
};
